// extracted by mini-css-extract-plugin
export default {"fieldset":"styles_fieldset__nuP63","input":"styles_input__9oTx2","label":"styles_label__PAFOP","error_message":"styles_error_message__+Ywty"};